/* Sheets (DESIGN_SYSTEM §6a): modal, beside the page (end) or rising from the bottom (phones). */
.overlay {
  position: fixed;
  inset: 0;
  z-index: 90;
  display: flex;
  background: var(--overlay);
}

/* The flex main axis follows the writing direction: flex-end is the inline end in RTL and LTR. */
.atEnd {
  justify-content: flex-end;
}

.atBottom {
  align-items: flex-end;
  justify-content: center;
}

.overlay[data-entering] {
  animation: sheet-fade var(--duration-base) var(--ease-out);
}

.sheet {
  display: flex;
  flex-direction: column;
  max-block-size: 100dvh;
  background: var(--color-surface);
  color: var(--color-text);
  box-shadow: var(--shadow-lg);
  outline: none;
}

.end {
  inline-size: min(34rem, 100%);
  block-size: 100dvh;
  border-inline-start: var(--border-width) solid var(--color-border);
}

.bottom {
  inline-size: 100%;
  max-block-size: 88dvh;
  border-start-start-radius: var(--radius-lg);
  border-start-end-radius: var(--radius-lg);
  padding-block-end: env(safe-area-inset-bottom, 0);
}

.end[data-entering] {
  animation: sheet-from-end var(--duration-base) var(--ease-out);
}

[dir='rtl'] .end[data-entering] {
  animation-name: sheet-from-end-rtl;
}

.bottom[data-entering] {
  animation: sheet-from-bottom var(--duration-base) var(--ease-out);
}

@keyframes sheet-fade {
  from {
    opacity: 0;
  }
}

@keyframes sheet-from-end {
  from {
    transform: translateX(100%);
  }
}

@keyframes sheet-from-end-rtl {
  from {
    transform: translateX(-100%);
  }
}

@keyframes sheet-from-bottom {
  from {
    transform: translateY(100%);
  }
}

.dialog {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-block-size: 0;
  outline: none;
}

.header {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-5);
  border-block-end: var(--border-width) solid var(--color-rule);
}

.title {
  flex: 1;
  min-inline-size: 0;
  font-size: var(--text-lg);
  overflow-wrap: anywhere;
}

.close {
  flex: none;
}

.body {
  flex: 1;
  min-block-size: 0;
  overflow: auto;
  padding: var(--space-4) var(--space-5);
}

.footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-5);
  border-block-start: var(--border-width) solid var(--color-rule);
  background: var(--color-surface);
}

@media (max-width: 40rem) {
  .end {
    inline-size: 100%;
    border-inline-start: 0;
  }

  .header,
  .body,
  .footer {
    padding-inline: var(--space-4);
  }

  .close {
    min-inline-size: 2.75rem;
    min-block-size: 2.75rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .overlay[data-entering],
  .end[data-entering],
  .bottom[data-entering] {
    animation: none;
  }
}
